import { render, staticRenderFns } from "./Maindash.vue?vue&type=template&id=3b1a4d37&scoped=true&"
import script from "./Maindash.vue?vue&type=script&lang=js&"
export * from "./Maindash.vue?vue&type=script&lang=js&"
import style0 from "./Maindash.vue?vue&type=style&index=0&id=3b1a4d37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1a4d37",
  null
  
)

export default component.exports